// A small, quiet tribute. Type "connie" anywhere (not in a box) and a note
// appears for a few seconds. Our test for every screen, CONNIE, and our design
// system, Elsie, are named for Constance "Connie" Elsie O'Shea, née Phillips.
import { Heart } from "@phosphor-icons/react";
import { useEffect, useState } from "react";

const WORD = "connie";

export function Connie() {
	const [shown, setShown] = useState(false);
	useEffect(() => {
		let typed = "";
		const onKey = (e: KeyboardEvent) => {
			const t = e.target as HTMLElement | null;
			if (t?.closest("input, textarea, select, [contenteditable]") || e.metaKey || e.ctrlKey || e.altKey) return;
			typed = (typed + e.key.toLowerCase()).slice(-WORD.length);
			if (typed === WORD) {
				typed = "";
				setShown(true);
			}
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, []);
	useEffect(() => {
		if (!shown) return;
		const t = setTimeout(() => setShown(false), 7000);
		return () => clearTimeout(t);
	}, [shown]);
	return (
		<div role="status" aria-live="polite" className="pointer-events-none fixed right-4 bottom-24 z-50 sm:bottom-6">
			{shown ? (
				<div className="pointer-events-auto max-w-80 rounded-[var(--radius-card)] border-2 border-b-4 border-purple bg-card p-4 shadow-lg">
					<p className="flex items-center gap-2 font-display font-bold">
						<Heart size={20} weight="fill" aria-hidden="true" className="text-pink" />
						For Connie
					</p>
					<p className="mt-1 text-sm">
						Every screen here has to be simple enough for Constance Elsie O'Shea, née Phillips. If it isn't, it isn't
						finished.
					</p>
				</div>
			) : null}
		</div>
	);
}

/** A one-line signature for anyone who opens the browser's console. */
export function signConsole() {
	console.info("%cBuilt with Elsie, for Connie.", "color:#7a4d9f;font-weight:bold");
}
